import React, { useContext } from "react";
import { ImageList, ImageListItem, ImageListItemBar, IconButton, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";

import { AppContext } from "../Store";
import { getChildImageUrl } from "../imageUtils";

const ChildImageGrid: React.FC<any> = ({ data }) => {
  const context = useContext(AppContext);
  const { user, userContext } = context;

  const isSmall = useMediaQuery("(max-width:1200px)");
  const isMedium = useMediaQuery("(max-width:1980px)");

  const getCols = () => {
    if (isSmall) return 2;
    if (isMedium) return 3;
    return 4;
  };

  return (
    <React.Fragment>
      <ImageList cols={getCols()} gap={8}>
        {data.map((child: any) => (
          <Link
            key={child.registration.childFirstName}
            to={{
              pathname: `/child/${child.id}`,
            }}
            state={{ child }}
            style={{ textDecoration: "none" }}
          >
            <ImageListItem key={child.registration.childFirstName}>
              <img src={getChildImageUrl(child.photoId)} style={{ height: 300 }} alt={child.registration.childFirstName} loading="lazy" />
              <ImageListItemBar
                sx={{
                  background: "linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, " + "rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
                }}
                title={userContext.isTeacher() ? child.keyTeacher : ""}
                position="top"
                actionIcon={
                  user === child.keyTeacher ? (
                    <IconButton sx={{ color: "gold" }}>
                      <StarIcon />
                    </IconButton>
                  ) : (
                    <IconButton sx={{ color: "white" }}>
                      <StarBorderIcon />
                    </IconButton>
                  )
                }
                actionPosition="left"
              />
              <ImageListItemBar title={`${child.registration.childFirstName} ${child.registration.childLastName}`} />
            </ImageListItem>
          </Link>
        ))}
      </ImageList>
    </React.Fragment>
  );
};

export default ChildImageGrid;
